import { render, staticRenderFns } from "./boxplotIcon.vue?vue&type=template&id=555c5e49&"
import script from "./boxplotIcon.vue?vue&type=script&lang=js&"
export * from "./boxplotIcon.vue?vue&type=script&lang=js&"
import style0 from "./boxplotIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports